const doc = [({"da":({"js":({"admin":({"orders":({"index":({"mark_the_order_to_require_manual_action":"Marker ordren til at kræve manuel handling?"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;